/**
 * Render function is used by Online Mastering pages
 * like https://dev.waves.com/olm
 */
import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import store from '../top-menu-mobile/data/store';
import TopMenuMobile from '../top-menu-mobile/ui/main';

window.waves = window.waves || {};
window.waves.renderExtHamburgerMenu = ($placeholder: HTMLElement) => {

    if (!$placeholder){
        console.error('Placeholder is not defined.');
        return;
    }

    $placeholder.classList.add('text-white');

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <TopMenuMobile />
            </Provider>
        </React.StrictMode>,
        $placeholder
    );
};

export {}